import { ComponentType } from 'react';
import { DirtyActionsGuard, DirtyActionsGuardAttributes } from './DirtyActionsGuard';

export function withDirtyActionsGuard<Props>(Component: ComponentType<Props & DirtyActionsGuardAttributes>) {
  return (props: Props) => (
    <DirtyActionsGuard>{(dirtyGuardProps) => <Component {...dirtyGuardProps} {...props} />}</DirtyActionsGuard>
  );
}
